import React, { useEffect, useState } from "react";
import LoginWindow from "app/Login/components/LoginWindow/LoginWindow"
import RegisterModal from "app/Login/components/RegisterModal/RegisterModal"
import BaseButton from "components/Button/BaseButton"
import useCognitoAuth, { AUTH_STEP } from "app/Login/hooks/useCognitoAuth";
import { useLanguage } from "context/LanguageContext";

import "./loginpage.scss";


const LoginPage = ({message}) => {

    const { t } = useLanguage();
    const [open, setOpen] = useState(false);
    const auth = useCognitoAuth();
    // const showCreateAccount = auth.step === AUTH_STEP.SIGN_IN || auth.step === AUTH_STEP.RESET_REQUEST;

    useEffect(() => {
        if (open && auth.step !== AUTH_STEP.SIGN_IN && auth.step !== AUTH_STEP.RESET_REQUEST) {
            setOpen(false);
        }
    }, [auth.step, open]);

    return (
        <div className="main loginPage">
            <div className="loginSplit">
                <section className="loginPanel">
                    <LoginWindow auth={auth}/>
                    {/* AWS Cognito account creation is disabled until the TSL pool is configured */}
                    {/* {showCreateAccount && (
                        <div className="createAccountContainer">
                            <BaseButton
                                type="button"
                                onClick={() => {
                                    auth.clearFeedback();
                                    setOpen(true);
                                }}
                                data-test="create-account-button"
                            >
                                Create account
                            </BaseButton>
                        </div>
                    )} */}
                </section>
                <section className="loginIntro">
                    <h2 className="loginIntroMessage">{message}</h2>
                    <p className="loginIntroDescription">
                        {t("login.intro")}
                    </p>
                </section>
            </div>
            <div className="appInfo">
                <h2>{t("login.poweredBy")}</h2>
            </div>
            {/* {open && <RegisterModal setOpen={setOpen} auth={auth}/>} */}
        </div>
    );
};

export default LoginPage;
